var map = {
	"./blog.yml": 108,
	"./cloud.yml": 109,
	"./color.yml": 110,
	"./country.yml": 111,
	"./dio.yml": 112,
	"./doc.yml": 113,
	"./emoji.yml": 114,
	"./git.yml": 115,
	"./icon.yml": 116,
	"./license.yml": 117,
	"./link.yml": 118,
	"./metrics.yml": 119,
	"./people.yml": 120,
	"./soft.yml": 121,
	"./src.yml": 122,
	"./status.yml": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;